import React from "react";
import { EMPTY_STRING } from "../../../constants";

const MainContentWrapper = (props) => {
  const { className = EMPTY_STRING } = props;
  return (
    <div className={`main-content-wrapper ${className}`}>{props.children}</div>
  );
};

export default MainContentWrapper;
